import React from 'react';
import { withTranslation } from 'react-i18next';
import { SharedLineChart } from '../charts/SharedLineChart';
import { CopyImageButton } from './CopyImageButton';

function DataExplorerLineChartComponent({ chartData, selectedMetrics, showTooltip, t }) {
    if (!chartData || !chartData.labels || !chartData.series || chartData.series.length === 0) {
        return (
            <div className="data-explorer-chart-container" style={{ width: '100%', height: '400px', marginBottom: '2rem', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f8f9fa', borderRadius: '4px', border: '1px solid #ddd' }}>
                <p style={{ color: '#6c757d', fontSize: '0.875rem' }}>
                    {t('data_explorer.no_chart_data', 'Seleccione métricas para visualizar el gráfico')}
                </p>
            </div>
        );
    }

    return (
        <CopyImageButton>
            <div className="data-explorer-chart-container" style={{ width: '100%', height: '400px', marginBottom: '2rem' }}>
                <SharedLineChart
                    chartData={chartData}
                    selectedMetrics={selectedMetrics}
                    showTooltip={showTooltip !== false}
                    height={400}
                />
            </div>
        </CopyImageButton>
    );
}

export const DataExplorerLineChart = withTranslation()(DataExplorerLineChartComponent);
